import { useState, useEffect } from 'react';

const WA_RESERVAR =
  "https://wa.me/5493415779623?text=Hola!%20Quiero%20reservar%20para%20ir%20a%20la%20Formaci%C3%B3n%20de%20Pergamino%20en%20La%20Usina%20Norte";
const WA_PROGRAMA =
  "https://wa.me/5493415779623?text=Hola!%20Quiero%20el%20programa%20completo%20de%20la%20Formaci%C3%B3n%20de%20Pergamino%20en%20La%20Usina%20Norte";

export default function HeroSection() {
  const [timeLeft, setTimeLeft] = useState({
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0,
  });

  useEffect(() => {
    const targetDate = new Date("2026-03-04T21:00:00").getTime();

    const interval = setInterval(() => {
      const now = new Date().getTime();
      const difference = targetDate - now;

      if (difference > 0) {
        setTimeLeft({
          days: Math.floor(difference / (1000 * 60 * 60 * 24)),
          hours: Math.floor((difference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)),
          minutes: Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60)),
          seconds: Math.floor((difference % (1000 * 60)) / 1000),
        });
      } else {
        // Countdown finished – set all values to zero and clear the interval
        setTimeLeft({ days: 0, hours: 0, minutes: 0, seconds: 0 });
        clearInterval(interval);
      }
    }, 1000);

    // Cleanup on unmount
    return () => clearInterval(interval);
  }, []);

  return (
    <section className="relative min-h-screen flex items-center justify-center bg-black text-white overflow-hidden pt-32">
      <div className="absolute inset-0">
        <img
          alt="Curso IA MenteIA"
          className="w-full h-full object-cover object-top"
          src="https://public.readdy.ai/ai/img_res/27a60e5fab3a39e50c33df47a085e2ec.jpg"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/50 to-black/60" />
      </div>

      <div className="w-full px-6 relative z-10">
        <div className="w-full max-w-7xl mx-auto text-center">
          {/* Title band */}
          <div className="relative">
            <div className="absolute -left-[50vw] -right-[50vw] top-0 bottom-0 bg-black/60 -mx-6" />
            <h1 className="relative text-4xl md:text-5xl lg:text-7xl font-bold uppercase tracking-tight mb-8 leading-tight py-6">
              IA Aplicada a tu Empresa <span className="text-teal-400">+</span>
              <br />
              Conversar para Vender:
              <br />
              El Método IA
            </h1>
          </div>

          {/* Badge */}
          <div className="inline-block bg-gradient-to-r from-teal-500 to-teal-400 px-8 py-4 rounded-xl mb-8 shadow-2xl border-4 border-white/30">
            <p className="text-2xl md:text-3xl font-black text-white uppercase tracking-wider drop-shadow-lg">
              ahora en pergamino
            </p>
          </div>

          {/* Event info */}
          <div className="space-y-4 text-xl md:text-2xl mb-10">
            <p className="font-medium">Curso presencial en Pergamino, Buenos Aires.</p>
            <p className="text-teal-400 font-bold">
              Jueves 5 de Marzo de 2026
            </p>
            <p className="font-bold">LA USINA NORTE</p>
            <a
              href="https://maps.google.com/?q=FLORIPONDIO+436+B2700+Pergamino+Buenos+Aires"
              target="_blank"
              rel="noopener noreferrer"
              className="text-teal-400 hover:text-teal-300 transition-colors underline cursor-pointer block text-base md:text-lg"
            >
              FLORIPONDIO 436, B2700 Pergamino, Provincia de Buenos Aires
            </a>
          </div>

          {/* Countdown + prices card */}
          <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-6 md:p-12 mb-10 max-w-3xl mx-auto border border-white/20">
            
            {/* CUPOS - Urgencia */}
            <div className="bg-red-900/80 border-2 border-red-500 rounded-xl p-5 mb-6 text-center">
              <p className="text-white/80 text-sm font-semibold uppercase tracking-widest mb-1">⚠️ Cupos disponibles</p>
              <div className="flex items-center justify-center gap-3 mb-3">
                <span className="text-7xl md:text-8xl font-black text-red-400 leading-none animate-pulse">9</span>
                <div className="text-left">
                  <p className="text-white/60 text-xs">de 40 totales</p>
                  <p className="text-red-300 font-bold text-sm">¡Casi agotado!</p>
                </div>
              </div>
              {/* Barra de progreso */}
              <div className="w-full bg-white/20 rounded-full h-3 overflow-hidden mb-2">
                <div
                  className="h-full bg-gradient-to-r from-red-500 to-orange-400 rounded-full"
                  style={{ width: '62.5%' }}
                />
              </div>
              <p className="text-white/70 text-xs">62% de los cupos ya reservados</p>
            </div>

            {/* Countdown */}
            <div className="bg-gradient-to-r from-red-600 to-orange-500 rounded-xl p-4 md:p-8 mb-8 shadow-2xl">
              <p className="text-white font-bold text-base md:text-lg mb-4 uppercase tracking-wide">
                ⏰ Venta de entradas hasta:
              </p>
              <div className="grid grid-cols-4 gap-2 md:gap-4">
                {[
                  { value: timeLeft.days, label: "Días" },
                  { value: timeLeft.hours, label: "Horas" },
                  { value: timeLeft.minutes, label: "Min" },
                  { value: timeLeft.seconds, label: "Seg" },
                ].map((item) => (
                  <div
                    key={item.label}
                    className="bg-white/20 backdrop-blur-sm rounded-lg p-2 md:p-4"
                  >
                    <div className="text-2xl md:text-4xl lg:text-5xl font-bold text-white">
                      {item.value}
                    </div>
                    <div className="text-xs md:text-sm text-white/90 uppercase mt-1 md:mt-2">
                      {item.label}
                    </div>
                  </div>
                ))}
              </div>
            </div>

            {/* Prices */}
            <div className="space-y-3 text-lg md:text-xl">
              <p className="text-base text-gray-300 mt-5">Transferencia: 5% off</p>
              <p className="text-base text-gray-300">Tarjeta: cuotas con interés</p>
            </div>
          </div>

          {/* CTA buttons */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center mb-8 mt-8">
            <a
              href={WA_RESERVAR}
              target="_blank"
              rel="noopener noreferrer"
              className="px-8 py-4 bg-teal-500 text-white rounded-lg font-semibold text-lg hover:bg-teal-400 hover:scale-110 transition-all duration-300 whitespace-nowrap cursor-pointer hover:shadow-2xl hover:shadow-teal-500/50"
            >
              Reservar por WhatsApp
            </a>
            <a
              href={WA_PROGRAMA}
              target="_blank"
              rel="noopener noreferrer"
              className="px-8 py-4 bg-white text-gray-900 rounded-lg font-semibold text-lg hover:bg-gray-200 hover:scale-110 transition-all duration-300 whitespace-nowrap cursor-pointer hover:shadow-2xl hover:shadow-white/50"
            >
              Pedir el programa
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
